
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team/signup",
      function () {
        return require("private-next-pages/team/signup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team/signup"])
      });
    }
  